import { createSlice } from "@reduxjs/toolkit";

const LoggedInUserSlice = createSlice({
  name: "loggedInUser", // better name than 'layout' for this context
  initialState: {
    userDetails: {},
  },
  reducers: {
    setLoggedInUserDetails: (state, action) => {
      state.userDetails = action.payload;
    },
  },
});

export const { setLoggedInUserDetails } = LoggedInUserSlice.actions;
export default LoggedInUserSlice.reducer;
